<template>
    <div class="all">
        <!-- 筛选 -->
        <div class="screen clearfix">
            <div class="fl">
                <div class="corm fr clearfix">
                    <router-link class="element" to='/analysis/presentationCenter'>简报列表</router-link>
                    <router-link class="element curr" to='/analysis/ordinaryTemplate'>自定义简报模板</router-link>
                    <router-link class="element" to='/analysis/timingTemplate'>定时报告模板</router-link>
                    <router-link class="element" to='/analysis/timelyReporting'>定时报告</router-link>
                </div>
            </div>
            <div class="fr">
                <button class="btn btn-jbblue" @click="addOrdinaryTemplate();"><i class="icons add-icon"></i>新建普通模板报告</button>
            </div>
        </div>
        <!-- 预警信息列表 -->
        <div class="warp mt20">
            <div class="warp-body">
                <table class="table" width="100%" border="0" cellpadding="0" cellspacing="0">
                    <colgroup>
                        <col width="30%">
                        <col width="20%">
                        <col width="10%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>默认模板</th>
                            <th>创建时间</th>
                            <th>操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in reportList" :key="index">
                            <td>{{item.tplName}}</td>
                            <td>{{item.createTime}}</td>
                            <td>
                                <div class="table-all-icons">
                                    <span v-if="item.id==1 || item.id==2">
                                        <i class="icons eye-icon" title="预览" @click="previewReport(item.id)"></i>
                                    </span>
                                    <span v-else>
                                        <i class="icons eye-icon" title="预览" @click="previewReport(item.id)"></i>
                                        <i class="icons edit-icon" title="修改" @click="editReport(item.id)"></i>
                                        <i class="icons del-icon" title="删除简报" @click="delReport(item.id)"></i>
                                    </span> 
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
                <!-- 分页 -->
                <page class="mt20" :currentPage.sync="currentPage" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            </div>
        </div>
        <Dialog ref="delDialog" :callback="delModal">
            <div slot="mdBox" >
                <div class="ac">确定删除报告吗？</div>
            </div>
        </Dialog>
	</div>
</template>
<script>
import page from '../../../components/page.vue';
import Dialog from '../../../components/dialog.vue';
export default {
    data() {
        return {
            caseId:'',
            reportList:[],
            currentPage: 1,//当前页码
            limit: 20,//每页显示条数
            totalCount:0,//总条数
            reportId:0,
            nodata:false
        }
    },
    components:{
        page,Dialog
    },
    created() {
		// 获取缓存方案数据
        this.caseId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    },
    mounted() {
		let that = this;
		that.$nextTick(()=> {
            that.dataAjax();
        })
    },
    methods: {
        dataAjax(type){
            let that = this;
            if(type === 1){//需要重置分页
                that.currentPage = 1;
            }
            that.$parent.loadModal(true,'数据加载中...');
            that.$api.get('report/template/list',{sid:that.caseId,perpage:that.limit,page:that.currentPage},r=>{
                that.$parent.loadModal(false);
                that.$utils.returnCode(r,function(){
                    that.reportList = r.data.list;
                    if(r.data.list.length<=0){
                        that.nodata = true;
                        return
                    }else{
                        that.nodata = false;
                    }
                    that.totalCount = Math.floor(r.data.count);
                });
            });
        },
        // 新增模板
        addOrdinaryTemplate () {
            this.$router.push({ path:'/analysis/addOrdinaryTemplate'})
            // let routeData = this.$router.resolve({ path: '/addOrdinaryTemplate'});
            // window.open(routeData.href, '_blank');
        },
        //删除报告
        delReport(id){
            let that = this;
            that.reportId = id;
            that.$refs.delDialog.showMaskFun();
        },
        delModal(){
            let that = this;
            that.$refs.delDialog.closeMask();
            that.$api.post('report/template/delete',{id:that.reportId},r=>{
                that.$utils.returnCode(r,function(){
                    that.$utils.alertText('删除成功！',200);
                    that.dataAjax(1)
                });
                
            });
        },
        editReport(id) {
            this.$router.push({ path:'/analysis/addOrdinaryTemplate',query:{id:id}})
            // let routeData = this.$router.resolve({ path: '/addOrdinaryTemplate',query:{id:id}});
            // window.open(routeData.href, '_blank');
        },
        previewReport(id) {
            this.$router.push({ path:'/analysis/addOrdinaryTemplate',query:{id:id,isPreview:true}})
            // let routeData = this.$router.resolve({ path: '/addOrdinaryTemplate',query:{id:id}});
            // window.open(routeData.href, '_blank');
        },
        getTableData() {
           this.dataAjax(0)
        },
	}
}
</script>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/presentation/ordinaryTemplate.vue